import { memo } from 'react';

/**
 * Allows for using `memo` with components that have generic props.
 */
export const typedMemo: <T>(c: T) => T = memo;
